// Target statuses of a credit request status change that trigger an email to the merchant.
// Only for these the "Notify merchant by email" checkbox is shown and `notify` may be sent.
const notifiableStatusValuesMap = {
  provider_status: ["approved", "rejected"],
  request_status: ["rejected"]
}

export const isNotifiableStatusChange = ({ status_type, status_value } = {}) =>
  !!notifiableStatusValuesMap?.[status_type]?.includes(status_value?.toLowerCase())

// Keep the default request shape untouched: `notify` is sent only when the email is suppressed.
export const buildNotifyPayload = (notify) => (notify === false ? { notify: false } : {})
